

// styles and images 
import './CreateProject.css'
import closeImg from '../../assets/close.svg'


export default function Close({setIsTriggered, title}) {
    
    return (
        <div className='d-flex justify-content-between title'>
            <h3>{title}</h3>
            <img 
                className='close'
                src={closeImg}
                alt='close img'
                onClick={() => setIsTriggered(false)}
            />
        </div>
    )
}
